import { Navigate, Outlet, useLocation } from "react-router-dom";
import qs from "query-string";
import useTrackPV from "logic/src/utils/useTrackPV";
import { pb } from "logic/src/services/auth";
import { useEffect } from "react";

const RouteWrapper = () => {
  const { search, pathname } = useLocation();
  useTrackPV();
  useEffect(() => {
    pb({
      page: pathname,
      from_url: document.referrer,
    });
  }, [pathname]);

  return <Outlet />;
};

export default RouteWrapper;
